
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Mission from '../pages/mission/page';
import App from '../pages/app/page';
import Education from '../pages/education/page';
import Supplementation from '../pages/supplementation/page';
import Testimonials from '../pages/testimonials/page';
import Impact from '../pages/impact/page';
import NotFound from '../pages/NotFound';
import Donate from '../pages/donate/page';
import ThankYou from '../pages/thank-you/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/mission',
    element: <Mission />,
  },
  {
    path: '/app',
    element: <App />,
  },
  {
    path: '/education',
    element: <Education />,
  },
  {
    path: '/supplementation',
    element: <Supplementation />,
  },
  {
    path: '/testimonials',
    element: <Testimonials />,
  },
  {
    path: '/impact',
    element: <Impact />,
  },
  {
    path: '/donate',
    element: <Donate />,
  },
  {
    path: '/thank-you',
    element: <ThankYou />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
